<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <!-- Mentions legales -->
<section id="faqs-1" class="bg-fixed bg-lightgrey wide-60 faqs-section division contact-bck">						
    <div class="container">


        <!-- SECTION TITLE -->	
        <div class="row">	
            <div class="col-md-10 offset-md-1 section-title">
                <!-- Title 	-->	
                <h2 class="h2-lg">Nos agences de {{ $route.params.id }} </h2>            
            <div>     
           
              <VueMultiselect  
                class="mselect" 
                v-model="value" 
                placeholder="Recherche une Agence par sa localité" 
                selectLabel=""
                deselectLabel=""
                selectedLabel="selectionné"
                label="nom" 
                track-by="id" 
                :options="localities" 
                :multiple="false" 
                @select="onSelect"
                >
              </VueMultiselect>


            </div>
           <!-- <div>la valeur : {{ value.id ? value.id : idAgence }}</div>       -->            
            </div>

            <!-- End row --> 	
        </div>	 <!-- END SECTION TITLE -->	

        <div class="row"> 

            <section class="card__list row" v-if=" listeAgence.length > 0 ">

                
                  <div class="card__box col-md-6 col-sm-12" v-for="agence_det in listeAgence" :key="agence_det.id">
                    <RouterLink :to=" '/agence/'+ slugify(agence_det.nom) +'-'+ agence_det.id "> <div class="card">
                      <div class="card__img">
                          <a href="#" target="_blank"><img class="card__img-preview" src="@/assets/images/weblogy-cocody.webp" alt="Image name"></a>
                          <div class="card-img-overlay"><span class="ouvert badge badge-pill badge-danger">Ouvert</span> </div>
                      </div>
                      <div class="card__content">
                          <h4 class="card__title"><RouterLink :to=" '/agence/'+ slugify(agence_det.nom) +'-'+ agence_det.id " target="_blank" class="title_c">{{ agence_det.nom }}</RouterLink></h4>
                          <p class="card__text"><i class="fa fa-map-marker" aria-hidden="true"></i> {{ agence_det.adresse }} </p>
                          <p class="card__description">{{agence_det.horaire1}} | {{agence_det.horaire2}}</p>
                          <div class="card__bottom">
                          <div class="options">
                              <span class="date">
                              <i class="fa fa-phone" aria-hidden="true"></i> {{agence_det.tel}}</span>
                              
                          </div>                          
                      </div>
                      </div>
                    </div></RouterLink>
                  </div>
                
                <!-- /card__box -->
</section>    
<section class="card__list row" v-if=" listeAgence.length <= 0 ">
  <div class="category" data-v-4257bfff=""><a href="" class="cat" data-v-4257bfff="">Aucune agence trouvée</a></div>
</section>
                    <div class="col-lg-10 offset-lg-1">
                        <div class="press-txt text-center m-top-20">	

                            <!-- Text -->
                            <p></p>
                            <p class="p-md">Nos équipes commerciales et techniques sont à votre écoute pour<br> répondre rapidement à tous vos besoins.
                            </p>

                            <!-- Button -->						
                            <RouterLink to="/nous-contacter" class="btn btn-lightorange ">Contacter le service client</RouterLink>

                        </div>
						</div>

                </div>	<!-- End row -->	

            </div>	   <!-- End container -->		
			</section>
        <!-- Mentions legales -->

       

        <footer_menu></footer_menu>
       
    </div>

</template>

<script>

import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';

import VueMultiselect from 'vue-multiselect'
import axios  from 'axios';
//import { response } from 'express';

export default{
    name :'nos_cartes',
    components:{
        VueMultiselect,

      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu,
     
    },

    data() {
    return {
      value: [],
      localities: [],
      idAgence: "",
      listeAgence: []

    
    };
  },

    methods: {
   
      getLocalities(){
        axios.get('https://carte.abidjan.net/assets-apaym/liste_localites.php').then(res => {
            console.log('>>>>>>>>>Success')
            this.localities = res.data
            console.log(this.localities)
        }).catch(error=>{
            console.log('>>>>>>>>> Error')
            console.log(error.response)
        })
    },

    onSelect(selectedOption) {
      this.$router.push("/agences/"+ selectedOption.id);
      this.$router.push("/agences/"+ this.slugify(selectedOption.nom));
      
     // console.log(selectedOption.id)
      window.localStorage.removeItem("id_point_de_vente");
      this.getAgences(selectedOption.id)
    },

    getAgences(id){
                var dataSend = new FormData() ;
                dataSend.append("id", id);

                axios.post("https://carte.abidjan.net/assets-apaym/liste_agences-regions.php",
                    dataSend
                ).then((res)=> {
                    //console.log(res.data)
                    // this.agence.nom = res.data.nom ;  
                    this.listeAgence = res.data ;
                    }).catch(error => {
                    console.log(error)
                })
            },


            // Slugity a string

            slugify(str)
            {
                str = str.replace(/^\s+|\s+$/g, '');

                // Make the string lowercase
                str = str.toLowerCase();

                // Remove accents, swap ñ for n, etc
                var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
                var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
                for (var i=0, l=from.length ; i<l ; i++) {
                    str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
                }

                // Remove invalid chars
                str = str.replace(/[^a-z0-9 -]/g, '')
                    // Collapse whitespace and replace by -
                    .replace(/\s+/g, '-')
                    // Collapse dashes
                    .replace(/-+/g, '-');

                return str;
            }, 

  },
  
  created() {
    this.getLocalities();
   
  },
  mounted() {
    this.getAgences();

      //console.log(id_rec); // Output: '197'
      this.idAgence = window.localStorage.getItem("id_point_de_vente") ;

      this.idAgence ? this.getAgences(this.idAgence) : "" ;
  }

}

</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped>
.category{
  background: #dedede;
    width: 300px;
    padding: 7px;
    border-radius: 20px;
    margin: auto;
    text-align: center;
    color: #fe9d02 !important;
}

.mselect{
    max-width: 440px;
    margin: auto;
    margin-top: 40px;
}

.ouvert{
    background: #4cb641;
    border-radius: 12px;
    border: none;
    color: #fff;
}


.options{
    font-weight: bold;
    font-size: 1rem;
    margin-top: 7px;
    color: #261b64;
}
.fa-map-marker, .fa-phone{
    color: #ff9e00;  
}
.title_c{
    color: #261b64;
}
.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-lightorange {
    color: #fff;
    background-color: #ff9e00;
    border-color: #f3a72e;
}



.card__list {
  max-width: 1200px;
  margin: 2rem auto;
}
.card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  flex-direction: row;
  height: 170px;
  margin-bottom: 1.5rem;
  -webkit-box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
          box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.25s ease-in;
  overflow: hidden;
}
.card:hover  {
  transform: translateY(-5px);
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
          box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.15);
}
@media(max-width: 768px) {
  .card {
    flex-direction: column !important;
    height: auto;
  }
}
.card__img{
  flex: 1 30%;
  -webkit-flex: 1 30%;
  overflow:hidden;
  position: relative;
  border-right: 1px solid #efefef;
}
.card__img-preview {
  display: block;
  object-fit: cover;
  margin: 0 auto;
  min-width: 150px;
  max-width: 100%;
  min-height: 100%;
  transition: all 0.5s ease 0s;
}
.card__img-preview:hover {
  transform: scale(1.5);
}
.card-img-overlay {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0.5rem;
}
.card__content {
  flex: 1 70%;
  -webkit-flex: 1 70%;
  padding: 0.8rem;
}
.card__title {
	font-size: 1.2rem;
  font-weight: 700;
  margin: 0;
  margin-bottom: 7px;
}
.card__text {
	font-size: 0.82rem;
  margin: 0;
  font-weight: 400;
}
.card__description {
	font-size: 0.9rem;
    margin: 0;
    margin-top: 1rem;
  color: #888;
	overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  max-height: 2rem;
  line-height: 1rem;
}
.card__bottom {
	display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
	align-content: center;
	-webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
	border-top: 1px solid #efefef;
  text-align: right;
	padding-top: 0.5rem;
	margin-top: 1rem;
	font-size: 0.8rem;
	color: #888;
}

</style>
